import React, {useState} from "react";
import { Link } from "react-router-dom";
import logo from '../../assets/images/sider-logo.svg';
import logoFull from "../../assets/images/sider-logo-full.svg";

type SiderLogoProps = {
  collapsed: boolean;
}

export const SiderLogo = ({collapsed} : SiderLogoProps) => {
  return (
    <div className="logo" style={{ margin: "16px", height: "32px", textAlign: "center" }} >
      <Link to="/">
        <img
          src={collapsed ? logo : logoFull}
          alt="bonibo logo"
          style={{ height: "32px", display: "inline-block" }}
        />
      </Link>
    </div>
  );
};
